const audioRecorderReducer = (state, { type, payload }) => {
  switch (type) {
    case 'STARTING':
      return { ...state, status: 'STARTING' }
    case 'STOPPING':
      return { ...state, status: 'STOPPING' }
    case 'RECORDING':
      return { ...state, status: 'RECORDING' }
    case 'RESUMING':
      return { ...state, status: 'RESUMING' }
    case 'PAUSING':
      return { ...state, status: 'PAUSING' }
    case 'PAUSED':
      return { ...state, status: 'PAUSED' }
    case 'STOPPED':
      return { ...state, status: 'STOPPED' }
    case 'INCREMENT_LENGTH':
      return { ...state, length: state.length + 1 }
    case 'RESET_LENGTH':
      return { ...state, length: 0 }
    case 'RESETTING':
      return { ...state, length: 0, title: '', recordedAudio: null, status: 'RESETTING' }
    case 'SET_AUDIO':
      return { ...state, recordedAudio: payload }
    case 'SET_TITLE':
      return { ...state, title: payload }
    case 'OPEN_AUDIO_DIALOG':
      return { ...state, status: 'OPEN_AUDIO_DIALOG' }
    case 'OPEN_TEXT_DIALOG':
      return { ...state, status: 'OPEN_TEXT_DIALOG' }
    case 'CLOSE_DIALOG':
      return { ...state, status: 'CLOSE_DIALOG' }
    case 'WAITING':
      return { ...state, status: 'WAITING' }
    default:
      return { ...state, status: 'STOPPED' }
  }
}
export default audioRecorderReducer
